import React, { useCallback, useState } from "react";
import Dropzone from "./Dropzone";
import ColorsFromImage from "./ColorsFromImage";
import {
  palette_from_image_wrapper,
  dropd_zone_and_palette_wrapper,
  subtitle,
  image_wrapper,
} from "../../../styles/modules/palette_from_image.module.css";

// Textos multiidioma
const TEXTS = {
  es: {
    title: "Extractor de Colores de Imagen",
    subtitle: "Sube una imagen y obtén su paleta de colores automáticamente",
  },
  en: {
    title: "Image Color Extractor",
    subtitle: "Upload an image and get its color palette automatically",
  },
  pt: {
    title: "Extrator de Cores de Imagem",
    subtitle:
      "Carregue uma imagem e obtenha sua paleta de cores automaticamente",
  },
  fr: {
    title: "Extracteur de Couleurs d'Image",
    subtitle:
      "Téléchargez une image et obtenez sa palette de couleurs automatiquement",
  },
  de: {
    title: "Bildfarben-Extraktor",
    subtitle: "Lade ein Bild hoch und erhalte automatisch seine Farbpalette",
  },
};

function PaletteFromImage({ locale }) {
  const texts = TEXTS[locale] || TEXTS.es;
  const [images, setImages] = useState([]);

  const onDrop = useCallback(acceptedFiles => {
    acceptedFiles.forEach(file => {
      const reader = new FileReader();
      reader.onload = function (e) {
        setImages([{ id: Date.now(), src: e.target.result, name: file.name }]);
      };
      reader.readAsDataURL(file);
    });
  }, []);

  const clearImage = useCallback(() => {
    setImages([]);
  }, []);

  return (
    <section className={palette_from_image_wrapper}>
      <h1>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          style={{ width: 28, height: 28, marginRight: 8 }}
        >
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
          <circle cx="8.5" cy="8.5" r="1.5" />
          <polyline points="21 15 16 10 5 21" />
        </svg>
        {texts.title}
      </h1>
      <p className={subtitle}>{texts.subtitle}</p>

      <div className={dropd_zone_and_palette_wrapper}>
        <div>
          <Dropzone onDrop={onDrop} accept={"image/*"} locale={locale} />

          {/* Imagen subida */}
          {images.length > 0 && (
            <div className={image_wrapper}>
              <img src={images[0].src} alt={images[0].name || "Uploaded"} />
            </div>
          )}
        </div>

        <ColorsFromImage locale={locale} images={images} onClear={clearImage} />
      </div>
    </section>
  );
}

export default PaletteFromImage;
